import {
  PurchaseHeader,
  PurchaseItem,
} from "app/modules/transactions/purchase/models/purchase.model";

/** Update purchase failure payload when backend returns `code: PURCHASE_BATCH_QTY_FLOOR`. */
export interface PurchaseStructuredSaveError {
  kind: 'purchase_batch_qty_floor';
  message: string;
  details?: {
    itemCode?: string;
    batchNo?: string;
    minRequired?: string;
    entered?: string;
    remaining?: string;
  };
}

export interface PurchaseFormState {
  header: PurchaseHeader | null;
  items: PurchaseItem[];
  loading: boolean;
  error: string | PurchaseStructuredSaveError | null;
  itemDetailsByRow: { [rowIndex: number]: any };
  saveSuccess: boolean;
  selectedPurchase: PurchaseHeader | null; // Added for update/edit
  createdPurchase: any | null; // Store created purchase response with ID
}

export const initialPurchaseFormState: PurchaseFormState = {
  header: null,
  items: [],
  loading: false,
  error: null,
  itemDetailsByRow: {},
  saveSuccess: false,
  selectedPurchase: null, // Added
  createdPurchase: null, // Added
};
